<template lang="pug">
.project-area(v-if="geoJson")
  l-marker(
    ref="marker"
    :lat-lng="getMarkerPositionByGeoJson(projectInfo, geoJson)"
    :icon="buildSmallIcon(projectInfo)"
    @click="emitClick({})"
    @mouseover="emitMouseover(projectInfo)"
    @mouseout="emitMouseout(projectInfo)"
  )
  l-geo-json(
    :geojson="geoJson"
    :options="options"
    :options-style="getDefaultLayerStyle"
  )
</template>

<script>
import { mapActions } from 'vuex'
import { getDefaultLayerStyle, buildSmallIcon } from '@/utils/map-utils.js'
import ProjectService from '@/services/projects.js'

export default {
  props: {
    map: {
      type: Object,
      default: null
    },
    geoJson: {
      type: Object,
      default: null
    },
    projectInfo: {
      type: Object,
      default: () => ({})
    },
    zoomProjectCode: {
      type: String,
      default: null
    }
  },
  mounted () {
    this.isMounted = true
    if (this.zoomProjectCode === this.projectInfo.code) this.setProjectInfoAndUpdateRoute({ projectInfo: this.projectInfo })
  },
  data () {
    const self = this
    return {
      refs: {},
      isMounted: false,
      descriptionIndex: 0,
      options: {

        filter: feature => feature.properties.parent,

        onEachFeature: (feature, layer) => {
          layer._leaflet_id = feature.properties.number
          self.refs = {
            feature,
            layer
          }
          layer.on({
            click: event => {
              event.originalEvent.stopPropagation()
              self.emitClick({ feature, layer })
            },
            mouseover: event => self.emitMouseover(self.projectInfo),
            mouseout: event => self.emitMouseout(self.projectInfo)
          })

          layer.options.isProject = true
          layer.bringToFront()
        }
      }
    }
  },
  methods: {

    ...mapActions([
      'hoverProject',
      'unHoverProject',
      'setProjectInfoAndUpdateRoute'
    ]),

    buildSmallIcon,

    getDefaultLayerStyle,

    getMarkerPositionByGeoJson: ProjectService.getMarkerPositionByGeoJson,

    getProjectAreaMapData (event) {
      if (event) {
        const { feature, layer, marker } = event
        return {
          feature: feature || this.refs.feature,
          layer: layer || this.refs.layer,
          marker: marker || this.markerMapObject,
          projectInfo: this.projectInfo
        }
      } else {
        return {
          feature: this.refs.feature,
          layer: this.refs.layer,
          marker: this.markerMapObject,
          projectInfo: this.projectInfo
        }
      }
    },

    emitClick (params) {
      this.setProjectInfoAndUpdateRoute({ projectInfo: this.projectInfo })
    },

    emitMouseover (projectData) {
      this.hoverProject(projectData)
    },

    emitMouseout (projectData) {
      this.unHoverProject(projectData)
    }
  },
  computed: {
    markerMapObject () {
      if (!this.isMounted) return
      return this.$refs.marker && this.$refs.marker.mapObject
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/map/map-scoped'
@import '~@/styles/map/refugios-scoped'

</style>
